export default __webpack_public_path__ + "static/media/textAlign-center.e3424e76.svg";